import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { View, Button } from "@/components/ui";
import { generateBookingChatSalesMessage, onChatSales } from "@/lib/chat-sales";
import { Typography } from "../typography";
import type { ServiceName } from "@/types/service";

export const FindBestHelperModal = ({
  open,
  setOpen,
  name,
}: {
  open: boolean;
  setOpen(open: boolean): void;
  name: ServiceName;
}) => {
  return (
    <BottomDrawerModal open={open} onOpenChange={setOpen} className="md:p-2">
      <View className="flex flex-col gap-4 md:p-3">
        <Typography variant="label-md" className="md:text-left">
          Let us find the best helper for your needs!
        </Typography>
        <Typography variant="body-sm" color="foreground-intermediate">
          You have chosen more than one session a week. Let our sales
          specialists understand your needs and find you the best possible
          match!
        </Typography>
        <Button
          variant="primary"
          color="success"
          fullWidth="full"
          rounded="full"
          onClick={() => {
            onChatSales(true, generateBookingChatSalesMessage(name));
          }}
          iconName="whatsappLogo"
          children="Chat Sales"
        />
      </View>
    </BottomDrawerModal>
  );
};
